import React from 'react';
import { Button } from '@99designs/common/components/Button';
import ErrorMessage from 'components/ErrorMessage';
import PropTypes from 'prop-types';

export default function ErrorTryAgain({ onRetry, message }) {
    return (
        <div>
            <p>
                <ErrorMessage error={{ message }} />
            </p>
            <Button variations={['secondary']} onClick={onRetry}>
                {__('Try again')}
            </Button>
        </div>
    );
}

ErrorTryAgain.defaultProps = {
    message: undefined,
};

ErrorTryAgain.propTypes = {
    onRetry: PropTypes.func.isRequired,
    message: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/js/components/ErrorTryAgain.jsx